import React from "react"

import { useForm } from "react-hook-form"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config.ts"
import { ButtonElement } from "@front-shared/elements/button.element.tsx"

import { LoginStep } from "../../../config/auth.config"
import { PhoneInputElement } from "../../../elements/phoneInput.element.tsx"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { authSetLoginStep } from "../../../store/slices/auth.slice"
import type { ICommonMFAProps } from "../../../types/props.types.ts"

export const PhoneNumberForm: React.FunctionComponent<
    IPhoneNumberFormProps
> = props => {
    const {
        handleSubmit,
        formState: { errors },
        control,
        watch,
    } = useForm()

    const dispatch = useAppDispatch()

    const phoneNumber = watch("phoneNumber")

    const onSubmit = async (
        data: Record<string, string> | { phoneNumber: string },
    ) => {
        props.onSubmit(data.phoneNumber)
    }

    return (
        <div className="relative">
            <form onSubmit={handleSubmit(onSubmit)} noValidate={true}>
                <PhoneInputElement
                    className="mb-[24px]"
                    name="phoneNumber"
                    label="Please enter your phone number"
                    isLabelStatic
                    reactHookControl={control}
                    reactHookErrors={errors}
                    reactHookValidations={{
                        required: FRONT_VALIDATION_CONFIG.required,
                    }}
                    onKeyDownEnter={handleSubmit(onSubmit)}
                    autoFocus
                    hideErrors
                    forceHighlightOnError
                />

                <div className="flex justify-between">
                    <ButtonElement
                        label="Back"
                        type="default"
                        htmlType="button"
                        size="large"
                        disabled={props.isCtaLoading}
                        onClick={() => {
                            dispatch(authSetLoginStep(LoginStep.MFA_SELECTION))
                        }}
                    />

                    <ButtonElement
                        label="Continue"
                        type="primary"
                        htmlType="submit"
                        size="large"
                        isLoading={props.isCtaLoading}
                        disabled={!phoneNumber}
                    />
                </div>
            </form>
        </div>
    )
}

interface IPhoneNumberFormProps extends ICommonMFAProps {
    onSubmit: (phoneNumber: string) => void
}
